const NoResult = () => {
  return <>No Result</>;
};

export default NoResult;
